import React from 'react';

const toImageList = (val) => {
  if (Array.isArray(val)) return val.filter((v) => typeof v === 'string' && v.trim() !== '');
  if (typeof val === 'string' && val.trim() !== '') return [val];
  return [];
};

// Compares diff values; arrays (e.g. additional_images) are compared by content.
export const diffValuesEqual = (a, b) => {
  const norm = (v) => (Array.isArray(v) ? JSON.stringify(v.filter(Boolean)) : String(v ?? ''));
  return norm(a) === norm(b);
};

// Renders one or more image thumbnails inside a diff cell. Click opens the full image in a new tab.
const DiffImages = ({ value, dimmed = false }) => {
  const urls = toImageList(value);
  if (urls.length === 0) return <span className="text-muted-foreground italic">—</span>;

  return (
    <div className="flex flex-wrap gap-2">
      {urls.map((url, idx) => (
        <a
          key={`${url}-${idx}`}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          title="Open full image"
          className="block"
        >
          <img
            src={url}
            alt={`Event image ${idx + 1}`}
            className={`w-24 h-24 rounded-lg object-cover border border-border bg-muted ${dimmed ? 'opacity-70' : ''}`}
            onError={(e) => {
              e.currentTarget.style.display = 'none';
              e.currentTarget.parentElement.textContent = 'Image unavailable';
            }}
          />
        </a>
      ))}
    </div>
  );
};

export default DiffImages;
